import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { BehaviorSubject, filter, map, Observable, of, switchMap, take, tap, throwError } from 'rxjs';
import { environment } from "environments/environment";
import { appCache } from "app/app.module";
import { RefTypCdDto } from 'app/modules/admin/core/ref-typ-cd-dto/ref-typ-cd-dto.model';


@Injectable({
    providedIn: 'root'
})
export class SEHelperService
{

    private _baseRefCds: BehaviorSubject<BaseRefCd[]> = new BehaviorSubject([]);
    private _baseRefTyps: BehaviorSubject<BaseRefTyp[]> = new BehaviorSubject([]);
    private _refTypCdDtos: BehaviorSubject<RefTypCdDto[]> = new BehaviorSubject([]);
    
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient,
                private _datePipe : DatePipe) {
        // this.getBaseRefTyps().subscribe(() => {});
    }



    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    
    /**
     * Get BaseRefCds
     */
    getBaseRefCds(): Observable<BaseRefCd[]> {
        let bRefCds = appCache.get(environment.seApiURL + '/base-reference-codes');
        if (bRefCds == undefined) {
            return this._httpClient.get<any>(environment.seApiURL + '/base-reference-codes').pipe(
                tap((baseRefCds) => {
                    this._baseRefCds.next(baseRefCds.content);
                    //this._baseRefCds.next(baseRefCdData);
                    appCache.set(environment.seApiURL + '/base-reference-codes', baseRefCds, 1800);
                })
            );
        } else {
            this._baseRefCds.next(bRefCds.content);
            return this._baseRefCds.asObservable();
        }
    }


    /**
     * Get BaseRefTyps
     */
    getBaseRefTyps(): Observable<BaseRefTyp[]> {
        let bRefCdTyps = appCache.get(environment.seApiURL + '/reference-types');
        if (bRefCdTyps == undefined) {
            return this._httpClient.get<any>(environment.seApiURL + '/reference-types').pipe(
                tap((baseRefTyps) => {
                    this._baseRefTyps.next(baseRefTyps.content);
                    //this._baseRefTyps.next(baseRefTypData);
                    appCache.set(environment.seApiURL + '/reference-types', baseRefTyps, 1800);
                })
            );
        } else {
            this._baseRefCds.next(bRefCdTyps.content);
            return this._baseRefTyps.asObservable();
        }
    }

     /**
     * Get BaseRefTyps
     */
      getRefTypCdDtos(): Observable<RefTypCdDto[]> {
        let cachedRefTypCdDtos = appCache.get(environment.seApiURL + '/reference-type-code-dtos');
        if (cachedRefTypCdDtos == undefined) {
            return this._httpClient.get<any>(environment.seApiURL + '/reference-type-code-dtos').pipe(
                tap((refTypCdDtos) => {
                    this._refTypCdDtos.next(refTypCdDtos.content);
                    //this._baseRefTyps.next(baseRefTypData);
                    appCache.set(environment.seApiURL + '/reference-type-code-dtos', refTypCdDtos, 1800);
                })
            );
        } else {
            this._refTypCdDtos.next(cachedRefTypCdDtos.content);
            return this._refTypCdDtos.asObservable();
        }
    }


    /**
     * 
     * @param refCdTyp 
     * @returns 
     */
    getBaseRefCdsByTyp(refCdTyp: string): BaseRefCd[] {
        let refCodes: BaseRefCd[] = [];
        refCdTyp = this._getCamelToSnakeCase(refCdTyp);

        for (const refType of this._baseRefTyps.getValue()) {
            if (refType.refCdTypNm == refCdTyp) {
                if (refType.pltfRefCds.length > 0) {
                    refCodes = refType.pltfRefCds;
                } else {
                    // The Refcode Type may be an alias, so look for parent refCodeType
                    if (refType.aliaRefCdTypId != null && refType.aliaRefCdTypId.length > 0) {
                        for (const aliaRefType of this._baseRefTyps.getValue()) {
                            if (aliaRefType.refCdTypId == refType.aliaRefCdTypId) {
                                refCodes = aliaRefType.pltfRefCds;

                                break;
                            }
                        }
                    }
                }
                
                break;
            }
        }

        return refCodes;
    }

        /**
     * 
     * @param refCdTyp 
     * @returns 
     */
         getRefCdsByTyp(refCdTyp: string): BaseRefCd[] {
            let refCodes: BaseRefCd[] = [];
            refCdTyp = this._getCamelToSnakeCase(refCdTyp);
    
            for (const refType of this._baseRefTyps.getValue()) {
                if (refType.refCdTypNm == refCdTyp) {
                    if (refType.pltfRefCds.length > 0) {
                        refCodes = refType.pltfRefCds;
                    } else {
                        // The Refcode Type may be an alias, so look for parent refCodeType
                        if (refType.aliaRefCdTypId != null && refType.aliaRefCdTypId.length > 0) {
                            for (const aliaRefType of this._baseRefTyps.getValue()) {
                                if (aliaRefType.refCdTypId == refType.aliaRefCdTypId) {
                                    refCodes = aliaRefType.pltfRefCds;
    
                                    break;
                                }
                            }
                        }
                    }
                    
                    break;
                }
            }
    
            return refCodes;
        }

         /**
     * 
     * @param refCdTyp 
     * @returns 
     */
        getRefTypCdDtosByColNm(colNm: string): RefTypCdDto[] {
            let refTypCdDtos : RefTypCdDto[] = [];
            let refTyp = this._getCamelToSnakeCase(colNm);
    
            for (const refTypCdDto of this._refTypCdDtos.getValue()) {
                if (refTypCdDto.refTypNm == refTyp) {
                    refTypCdDtos.push(refTypCdDto);                    
                }
            }
            return refTypCdDtos;
        }

        getRefCdValForColNm(colNm: string, refCdIntVal: number): string
        {
            if (refCdIntVal == null) {
                return "N/A";
            }
            let refTypCdDtos : RefTypCdDto[] = [];
            let refTyp = this._getCamelToSnakeCase(colNm);
            let refCdDispVal = refCdIntVal.toString();
    
            for (const refTypCdDto of this._refTypCdDtos.getValue()) {
                if (refTypCdDto.refTypNm == refTyp && refTypCdDto.refCd == refCdIntVal) {
                    refCdDispVal = refTypCdDto.refCdDispVal;
                    break;                  
                }
            }
            
          return refCdDispVal;
        }    

        formatDateTime(strDate:string) : string
        {
            if (strDate != null) {
                console.log("Date "+strDate);
                let dt = Date.parse(strDate);
                return this._datePipe.transform(dt, 'dd MMM, yyyy');
            } else {
                return "Not Available";
            }

        }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    private _getCamelToSnakeCase(varName: string): string {
        var result = varName.replace( /([A-Z])/g, " $1" );
        return result.split(' ').join('_').toLowerCase();
    }
}



export class BaseRefTyp {
    refCdTypId : string;
    refCdTypNm : string;
    aliaRefCdTypId: string;
    crtUsrId : string;
    descTxt: string;
    eftvFrmTs: string;
    eftvToTs: string;
    isOrgOvrdEnbl : boolean;
    valFmt: string;
    pltfRefCds: BaseRefCd[];
}



export class BaseRefCd {
    pltfRefCdId: string;
    refCdId : number;
    refCdTypId : string;
    refCdDispVal : string;
    refCdDesc : string;
    crtUsrId : string;
    eftvFrmTs: string;
    eftvToTs: string;
    orgRefCds: any[];    
}